import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { getPublicActivities } from "@/lib/webContentApi";
import { ActivityItem } from "@/lib/webContentTypes";

export default function ActivitiesSection() {
  const [upcoming, setUpcoming] = useState<ActivityItem[]>([]);

  useEffect(() => {
    getPublicActivities(3)
      .then((items) => setUpcoming(items.filter((item) => item.active).slice(0, 3)))
      .catch(() => setUpcoming([]));
  }, []);

  return (
    <section className="py-20 px-4 md:px-8 bg-sky-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-12">
          <div>
            <span className="text-emerald-600 text-sm font-semibold uppercase tracking-wider">Proximas fechas</span>
            <h2
              className="text-3xl md:text-4xl font-extrabold text-sky-900 mt-1"
              style={{ fontFamily: "'Poppins', sans-serif" }}
            >
              Actividades y Eventos
            </h2>
            <p className="text-slate-500 mt-2 text-base">
              Reuniones, operativos y eventos comunitarios del APR.
            </p>
          </div>
          <Link
            to="/actividades"
            className="flex items-center gap-2 px-6 py-3 rounded-full border-2 border-emerald-500 text-emerald-600 font-semibold text-sm hover:bg-emerald-50 transition-colors cursor-pointer whitespace-nowrap self-start md:self-auto"
          >
            Ver todas <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {upcoming.map((activity) => {
            const d = new Date(activity.date);
            const day = d.toLocaleDateString("es-CL", { day: "2-digit" });
            const month = d.toLocaleDateString("es-CL", { month: "short" }).toUpperCase();
            const year = d.getFullYear();

            return (
              <div
                key={activity.id}
                className="bg-white rounded-2xl overflow-hidden border border-sky-100 hover:-translate-y-1 transition-transform duration-300"
              >
                <div className="h-44 overflow-hidden">
                  <img
                    src={activity.imageUrl}
                    alt={activity.title}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="p-6">
                  <div className="flex items-center gap-4 mb-4">
                    <div className="flex flex-col items-center justify-center w-14 h-14 rounded-xl bg-sky-100 flex-shrink-0">
                      <span className="text-2xl font-extrabold text-sky-700 leading-none">{day}</span>
                      <span className="text-xs font-bold text-sky-500 leading-none mt-0.5">{month}</span>
                    </div>
                    <div>
                      <h3 className="font-bold text-sky-900 text-base leading-snug">{activity.title}</h3>
                      <span className="text-xs text-slate-400">{year}</span>
                    </div>
                  </div>
                  <p className="text-slate-600 text-sm leading-relaxed line-clamp-2 mb-3">
                    {activity.summary || activity.content}
                  </p>
                  <div className="flex items-center gap-1.5 text-slate-400 text-xs">
                    <i className="ri-map-pin-line text-sky-400"></i>
                    <span className="truncate">{activity.location}</span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
